import IconChooseCountry from '@/components/@icons/IconChooseCountry.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "CountryModal",
  components: {
    IconChooseCountry,
  },
  computed: {
    ...mapGetters({
      regionsList: 'regions/regionsList',
      regionsListLoaded: 'regions/regionsListLoaded',
    }),
    sortedRegionList() {
      return this.regionsList.slice().sort((a, b) => a.name.localeCompare(b.name))
    },
  },
  async created() {
    await this.GET_REGIONS_LIST()
    this.checkGeolocation()
  },
  methods: {
    ...mapActions({
      GET_REGIONS_LIST: 'regions/GET_REGIONS_LIST',
    }),
    selectCountry(alpha2code) {
      localStorage.setItem('app_locale', alpha2code === 'CZ' ? 'cz' : 'en')
      localStorage.setItem('country', alpha2code)
      localStorage.removeItem('products')
      window.location.reload()
    },
    checkGeolocation() {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(this.handleGeolocationSuccess, this.handleGeolocationError)
      }
    },
    async handleGeolocationSuccess(position) {
      try {
        const response = await fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=en`
        )
        const data = await response.json()
        const userCountryCode = data.countryCode

        if (userCountryCode === 'UA') {
          window.location.href = 'https://skinon.com.ua/'
          return
        }

        const matchingCountry = this.regionsList.find((region) => region.alpha2Code === userCountryCode)

        if (matchingCountry) {
          this.selectCountry(matchingCountry.alpha2Code)
        }
      } catch (error) {
        console.log('Error getting location details:', error)
      }
    },
    handleGeolocationError(error) {
      console.log('Geolocation error:', error)
    },
  },
}
